export default __webpack_public_path__ + "static/media/SEI_TRAN.463b3063.png";